import PropTypes from 'prop-types';
import Drawer from '@material-ui/core/Drawer';
import Button from '@base/Button/Button';
import { getImage } from '@utils/imageHelper';
import React from 'react';
import styled from '@emotion/styled';
import H4 from '@base/H4/H4';
import P1 from '@base/P1/P1';

const Container = styled(Drawer)`
  display: none;
  &.MuiDrawer-root > .MuiPaper-root {
    background: linear-gradient(
        0deg,
        var(--color-i-blue-5) 0%,
        var(--color-i-blue-6) 100%
      ),
      var(--color-i-white);
    box-shadow: 0px -8px 24px var(--color-shadow);
    border-radius: 16px 16px 0px 0px;
    overflow: hidden;
  }
  @media (max-width: 47.95em) {
    display: block;
  }
`;

const Wrapper = styled.div`
  text-align: center;
  background: url(${getImage('goal/learn-bg.png')}) no-repeat;
  background-size: 197px 130px;
  background-position: top 32px center;
`;

const Title = styled(H4)`
  @media (max-width: 47.95em) {
    font-size: 22px;
    line-height: 150%;
    text-align: center;
    margin-bottom: 8px;
  }
`;

const SubTitle = styled(P1)`
  text-align: center;
  padding: 0 36px;
`;

const DownloadButton = styled(Button)`
  width: calc(100% - 32px);
  margin: 24px 16px;
`;

const Image = styled.img`
  object-fit: contain;
  margin: 32px auto 36px;
`;

const CloseIcon = styled.img`
  position: absolute;
  right: 16px;
  top: 16px;
`;

export default function Version1({ installLink, onClose, open }) {
  const handleClick = () => {
    window.open(installLink, '_blank');
  };
  return (
    <Container anchor="bottom" open={open} onClose={onClose}>
      <Wrapper>
        <CloseIcon
          src={getImage('k12/close-circle-filled.png')}
          alt="close"
          width="24"
          height="24"
          onClick={onClose}
          aria-hidden="true"
        />
        <Image
          src={getImage('goal/learn.png')}
          alt="Download Unacademy app"
          width="140"
          height="120"
        />
        <Title>Get the app to continue</Title>
        <SubTitle>
          Watch live classes, take tests, combats and a lot more on the app
        </SubTitle>
        <DownloadButton label="Get the Unacademy app" onClick={handleClick} />
      </Wrapper>
    </Container>
  );
}

Version1.propTypes = {
  installLink: PropTypes.string,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

Version1.defaultProps = {
  installLink: 'https://unacademy.app.link/LtwR6CRyLcb'
};
